export default {
    message: {
        "Ricerca_prodotti": "Ricerca prodotti",
        "Catalogo": "Catalogo",
        "Area": "Area",
        "Categorie": "Categorie",
        "Marchi": "Marchi",
        "Stagione": "Stagione",
        "Prezzo": "Prezzo",
        "Genere": "Genere",
        "Pagina": "Pagina",
        "di": "di",
        "Cerca": "Cerca",
        "vedi": "vedi",
        "totali": "totali",
        "Nessun prodotto trovato": "Nessun prodotto trovato",
        "Caricamento prodotti in corso": "Caricamento prodotti in corso",
        "Aggiungi al carrello": "Aggiungi al carrello",
        "Loading": "Caricamento in corso ...",
    },
}
